// generate colors for text, main color and background color etc for dark mode
export const colors = {
  darkMode: {
    background: "#141414",
    layer1: "#191919",
    layer2: "#222222",
    layer3: "#323232",
    text: "#e1e1e1",
    subText: "#c1c1c1",
    red: "#ff3e40",
    lightRed: "#ff5e60",
    red0: "#ff6061",
    lightGreen: "#b0fedb",
    green: "#01e47c",
    darkGreen: "#005930",
    greenDarker: "#019853",
    redDarker: "#7f3c3c",
  },
};
